import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetRebateGroupDTO from "../../../../models/DTO/IGetRebateGroupDTO";
import IOnCreateRebateGroupDTO from "../../../../models/DTO/IOnCreateRebateGroupDTO";
import IOnGetRebateGroupDTO from "../../../../models/DTO/IOnGetRebateGroupDTO";
import IOnUpdateRebateGroupDTO from "../../../../models/DTO/IOnUpdateRebateGroupDTO";
import IUpdateRebateGroupDTO from "../../../../models/DTO/IUpdateRebateGroupDTO";
import INotification from "../../../../models/INotification";
import IRebate from "../../../../models/IRebate";
import IRebate_Group from "../../../../models/IRebate_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import { LoadingResults } from "../../../shared/LoadingResults/LoadingResults";
import NoResults from "../../../shared/NoResults/NoResults";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import RebateTierRow from "./RebateTierRow/RebateTierRow";
import { Socket } from "socket.io-client";

type Props = {
    toggleSidebar: (shouldBeVisible?: boolean, refreshData?: boolean) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    rebateGroup?: IRebate_Group;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    rebateGroup: IRebate_Group;
    rebates: IRebate[];
    disableSave: boolean;
    activeSave: boolean;
    resultsLoaded: boolean;
};

class RebateGroupSidebar extends Component<Props, State> {
    readonly state: State = {
        rebateGroup: this.props.rebateGroup || ({ name: "" } as IRebate_Group),
        rebates: this.props.rebateGroup && this.props.rebateGroup.Rebates ? this.props.rebateGroup.Rebates : [],
        disableSave: false,
        activeSave: false,
        resultsLoaded: false,
    };

    componentDidMount(): void {
        this.props.socket.on("onGetRebateGroup", this.onGetRebateGroup);
        this.props.socket.on("onUpdateRebateGroup", this.onUpdateRebateGroup);
        this.props.socket.on("onCreateRebateGroup", this.onCreateRebateGroup);

        this.getRebateGroup();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onGetRebateGroup", this.onGetRebateGroup);
        this.props.socket.removeListener("onUpdateRebateGroup", this.onUpdateRebateGroup);
        this.props.socket.removeListener("onCreateRebateGroup", this.onCreateRebateGroup);
    }

    getRebateGroup = () => {
        let resultsLoaded = false;

        if (!this.props.rebateGroup) {
            resultsLoaded = true;
        }

        this.setState(
            {
                resultsLoaded,
            },
            () => {
                if (!this.props.rebateGroup) {
                    return;
                }

                const payload: IGetRebateGroupDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    rebateGroup: this.props.rebateGroup,
                };

                this.props.socket.emit("getRebateGroup", payload);
            }
        );
    };

    onGetRebateGroup = (data: IOnGetRebateGroupDTO) => {
        this.setState({
            rebateGroup: data.rebateGroup,
            rebates: data.rebateGroup.Rebates || [],
            resultsLoaded: true,
        });
    };

    onUpdateRebateGroup = (data: IOnUpdateRebateGroupDTO) => {
        const notification: INotification = {
            title: "successfully_updated_rebate_group",
            position: NotificationPositionEnum.br,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);
        // refresh the tiers.
        this.cancel(true);
    };

    onCreateRebateGroup = (data: IOnCreateRebateGroupDTO) => {
        const notification: INotification = {
            title: "successfully_created_rebate_group",
            position: NotificationPositionEnum.br,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);
        // refresh the tiers.
        this.cancel(true);
    };

    cancel = (refreshData?: boolean) => {
        this.props.toggleSidebar(false, refreshData);
    };

    saveRebates = () => {
        const payload: IUpdateRebateGroupDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            rebateGroup: this.state.rebateGroup,
            rebates: this.state.rebates || [],
        };

        if (payload.rebateGroup.id) {
            this.props.socket.emit("updateRebateGroup", payload);
        } else {
            this.props.socket.emit("createRebateGroup", payload);
        }
    };

    addRebate = () => {
        // show a new row to add.
        const newRebate: Partial<IRebate> = {
            percent: 0,
        };

        const rebates = [...this.state.rebates, newRebate as IRebate];

        this.setState({
            rebates,
        });
    };

    handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const name = e.target.name;

        const rebateGroup = this.state.rebateGroup;

        // @ts-expect-error
        rebateGroup[name] = value;

        this.setState({
            rebateGroup,
        });
    };

    cancelRow = (index: number) => {
        const rebates = this.state.rebates;

        if (rebates[index]) {
            if (rebates[index].guid) {
                // rebates[index]
            }
        }
    };

    render() {
        const resultsLoaded = this.state.resultsLoaded;
        const noResults = this.state.resultsLoaded && !this.state.rebates.length;

        let rebates: any = <LoadingResults />;

        if (resultsLoaded) {
            if (noResults) {
                rebates = <NoResults tag={"h6"} pleaseAdd={true} />;
            } else {
                rebates = this.state.rebates.map((rebate: IRebate, index: number) => {
                    if (rebate) {
                        return <RebateTierRow key={rebate.guid} index={index} rebate={rebate} cancelFn={this.cancelRow} />;
                    } else {
                        return null;
                    }
                });
            }
        }

        return (
            <div className="RebateGroupSidebar p-3" style={{ height: "100vh", overflow: "hidden" }}>
                <div style={{ height: "15vh" }}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle leftIconName={"fad fa-money-check-alt"} title={"rebates"} />
                    <hr />
                </div>
                <div className="PriceGroupForm pb-2 flex-grow mb-2" style={{ height: "85vh", overflowY: "scroll" }}>
                    <div>
                        <OwTitle title={"rebate_group_name"} tag={"h5"} />
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.rebateGroup.name} />
                    </div>

                    <div className={"mt-4 mb-4 d-flex align-items-center"}>
                        <OwTitle title={"rebate_tiers"} tag={"h5"} />
                        <div className={"ms-2"}>
                            <OwButton fn={this.addRebate} title={"add"} leftIconClass={"far fa-plus"} />
                        </div>
                    </div>
                    <div className={"mb-4"}>{rebates}</div>

                    <div>
                        <OwButton
                            disabled={this.state.disableSave}
                            active={this.state.activeSave}
                            leftIconClass=""
                            className="btn-primary me-2"
                            title="save"
                            fn={this.saveRebates}
                        />

                        <OwButton
                            className={"btn-danger"}
                            fn={() => {
                                this.cancel();
                            }}
                            title={"cancel"}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default RebateGroupSidebar;
